import React from "react";
import FLOWDIA_loading from "../dist/img/FLOWDIA_loading.mp4";

const Loading = () => {
  return (
    <section className="c-loading">
      <video muted autoPlay loop playsInline muted>
        <source src={FLOWDIA_loading} type="video/mp4"></source>
      </video>
      <div>
        <span></span>
        <span></span>
        <span></span>
        <p>
          Now Loading<span></span>
          <span></span>
          <span></span>
        </p>
      </div>
    </section>
  );
};

export default Loading;
